
import { useState, useEffect } from 'react';

import { getMasterData, deleteMasterData } from '../../api';

export const useMasterData = () => {
  const [values, updateValues] = useState([]);
  const [loading, updateLoading] = useState(false);

  const deleteItem = id => async () => {
    updateLoading(true);
    const resp = await deleteMasterData(id);
    updateLoading(false);

    if (resp !== undefined) {
      updateValues(values.filter(item => item.id !== id));
    }
  };

  const reloadData = async () => {
    updateLoading(true);
    const response = await getMasterData();
    updateLoading(false);

    if (response) {
      updateValues(response);
    }
  };

  useEffect(() => {
    reloadData();
  }, []);

  return [values, loading, deleteItem, reloadData];
};
